import Component from '@glimmer/component';
import styles from './styles.css';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface GlobalSocialArgs {}

export default class GlobalSocial extends Component<GlobalSocialArgs> {
  styles = styles;
}
